import { ABSENCE_TYPES, AbsenceType } from '@app/shared/types/enums/absence-type';
import { HoursType } from '@app/shared/types/enums/hours-type';
import { RegistrationType } from '@app/shared/types/enums/registration-type';
import { TimeZone } from '@app/shared/types/enums/time-zone';
import { TimeReportStatus } from '@app/shared/types/models/reports/time-report';

const ABSENCE_TYPE_BY_LOWER = new Map<string, AbsenceType>(ABSENCE_TYPES.map(type => [type.toLowerCase(), type]));

export class ReportMappers {
  public static mapAbsenceType(report: string): AbsenceType {
    if (!report) {
      return undefined;
    }

    const mapped = ABSENCE_TYPE_BY_LOWER.get(report.toLowerCase());
    if (!mapped) {
      throw Error(`Unrecognized AbsenceType: ${report}`);
    }

    return mapped;
  }

  public static mapStatus(value: string): TimeReportStatus | undefined {
    if (!value) {
      return undefined;
    }

    switch (value.toLowerCase()) {
      case 'pending':
        return TimeReportStatus.PENDING;
      case 'approved':
        return TimeReportStatus.APPROVED;
      case 'processed':
        return TimeReportStatus.PROCESSED;
      default:
        throw Error('Unrecognized TimeReportStatus');
    }
  }

  public static mapHoursType(value: string): HoursType | undefined {
    if (!value) {
      return undefined;
    }

    switch (value.toLowerCase()) {
      case 'auto':
        return 'Auto';
      case 'ordinaryhours':
        return 'OrdinaryHours';
      case 'bankplus':
        return 'BankPlus';
      case 'bankminus':
        return 'BankMinus';
      case 'overtime50':
        return 'Overtime50';
      case 'overtime100':
        return 'Overtime100';
      case 'manual':
        return 'Manual';
      default:
        throw Error('Unrecognized Hour type');
    }
  }

  public static mapRegistrationType(value: string): RegistrationType | undefined {
    if (!value) {
      return undefined;
    }

    switch (value.toLowerCase()) {
      case 'timer':
        return 'Timer';
      case 'manual':
        return 'Manual';
      case 'range':
        return 'Range';
      case 'absence':
        return 'Absence';
      default:
        throw Error('Unrecognized RegistrationType');
    }
  }

  public static mapTimeZone(value: string): TimeZone | undefined {
    if (!value) {
      return undefined;
    }

    switch (value.toLowerCase()) {
      case 'oslo':
        return 'Oslo';
      case 'utc':
        return 'Utc';
      case 'warsaw':
        return 'Warsaw';
      case 'dublin':
        return 'Dublin';
      default:
        throw Error('Unrecognized TimeZone');
    }
  }
}
